import { LoadingPage } from '@/components/loading-page';
import { validateRouteRole } from '@/lib/routing';
import { isCoach } from '@airreading/common';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

export const Route = createFileRoute('/_layout/handbook/')({
  beforeLoad: validateRouteRole(isCoach),
  component: Page,
});

function Page() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <PageDetail />
    </Suspense>
  );
}

function PageDetail() {
  const url =
    'https://docs.google.com/document/u/7/d/e/2PACX-1vTitCHLXa0OcdWRbsSpx0QEuOGAffYUTZYA7H9K7hcJNJWoJEhaZV_AUKtu2E0TkF2CaopUQJuc_psS/pub?embedded=true';

  return (
    <iframe
      allowFullScreen={true}
      src={url}
      className="h-full w-full border border-gray-200 shadow-md rounded-lg"
    ></iframe>
  );
}
